<template>
  <div class="d-input-group input-group" :class="[{ disabled: disabled }, _variant]">
    <span v-if="title" class="title">{{ title }}</span>
    <div class="input-field d-flex w-100 align-content-center">
      <input :type="type" class="form-control shadow-none flex-grow-1" :name="name" :id="id" aria-label="Small" :pattern="_pattern" :autocomplete="autocomplete"
        aria-describedby="inputGroup-sizing-default" v-model="model" :disabled="disabled" :placeholder="_placeholder"
        @keydown="OnChange()" @keydown.enter="OnEnter()" />
    </div>
    <span v-if="message" class="message" :class="_message_color_class">{{ message }}</span>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineModel, defineProps } from 'vue';

import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(); // Use the globally registered store

const emit = defineEmits(['change', 'enter', 'click']);

const model = defineModel();

const props = defineProps({
  id: {
    type: String,
    required: false
  },
  name: {
    type: String,
    required: false
  },
  title: {
    type: String,
    required: false
  },
  type: {
    type: String,
    default: "text"
  },
  message: {
    type: String,
    required: false
  },
  placeholder: {
    type: String,
    required: false,
    default: '...'
  },
  disabled: {
    type: Boolean,
    required: false
  },
  variant: {
    type: String,
    required: false
  },
  danger: {
    type: Boolean,
    required: false
  },
  autocomplete: {
    type: String,
    required: false
  },
});

// COMPUTED

const _variant = computed(() => {
  return props.variant ?? '';
});

const _message_color_class = computed(() => {
  if (!_variant.value) return;

  return 'text-' + _variant.value;
});

const _pattern = computed(() => props.type.toLowerCase() == "number" ? "\\d*" : "")

const _placeholder = computed(() => translationsStore.translate(props.placeholder))

// FUNCTIONS

const OnChange = () => {
  emit('change', model);
};

const OnEnter = () => {
  emit('enter', model);
};

</script>

<style lang="scss">

</style>